import { getWeekday } from '@zazume/zzm-utils';

import { Weekday } from './CalendarComponent';

const tryParseDate = (day: number, month: number, year: number): Date | null => {
  if (month < 1 || month > 12 || day < 1 || day > 31) {
    return null;
  }
  const parsed = new Date(year, month - 1, day);
  if (parsed.getFullYear() !== year || parsed.getMonth() !== month - 1 || parsed.getDate() !== day) {
    return null;
  }
  return parsed;
};

export const parseDateInput = (text: string): Date | null => {
  if (!text.trim()) {
    return null;
  }

  const match = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!match) {
    return null;
  }

  const [, first, second, y] = match;
  const a = parseInt(first);
  const b = parseInt(second);
  const year = parseInt(y);

  return tryParseDate(a, b, year) ?? tryParseDate(b, a, year);
};

const expandDisabledDays = (disabledDays: Weekday[]): string[] => {
  let expanded = [...disabledDays];

  if (disabledDays.includes('Weekend')) {
    expanded = expanded.concat(['Saturday', 'Sunday']);
  }

  if (disabledDays.includes('Weekdays')) {
    expanded = expanded.concat(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']);
  }

  return expanded;
};

export const isDateSelectable = (date: Date, minDate?: Date, maxDate?: Date, disabledDays?: Weekday[]): boolean => {
  if (minDate && date < minDate) {
    return false;
  }

  if (maxDate && date > maxDate) {
    return false;
  }

  if (disabledDays?.length) {
    const weekday = getWeekday(date);
    const expanded = expandDisabledDays(disabledDays);
    if (expanded.includes(weekday)) {
      return false;
    }
  }

  return true;
};

export const toSafeDate = (value: any): Date | null => {
  if (!value) {
    return null;
  }
  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }
  const date = new Date(value);
  return isNaN(date.getTime()) ? null : date;
};
